import axios from 'axios';
import { getConfig } from '../config/config';

const { authUrl, orderUrl } = getConfig();

const config = token => {
  return {
    headers: {
      'Content-type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  };
};

const formDataConfig = token => {
  return {
    headers: {
      'Content-type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  };
};

export const signupService = formValues => axios.post(`${authUrl}/register`, formValues, config());

export const validateOTP = formValues =>
  axios.post(`${authUrl}/validate-email`, formValues, config());

export const signinService = formValues => axios.post(`${authUrl}/login`, formValues);

export const updateUserPassword = (formValues, token) =>
  axios.put(`${authUrl}/password/update`, formValues, config(token));

export const updateUserProfile = (formValues, token) =>
  axios.put(`${authUrl}/me/update`, formValues, formDataConfig(token));

export const getUserDetails = token => axios.get(`${authUrl}/my_account`, config(token));

export function submitData(type, token, values, id) {
  switch (type) {
    case 'addBillingAddress':
      return axios.post(`${authUrl}/billingAddress/add`, values, config(token));
    case 'editBillingAddress':
      return axios.post(`${authUrl}/billingAddress/edit/${id}`, values, config(token));
    case 'placeUserOrder':
      return axios.post(`${orderUrl}/create`, values, config(token));
    case 'proceedPayment':
      return axios.post(`${orderUrl}/payment`, values, config(token));
    case 'verifyOrderPayment':
      return axios.post(`${orderUrl}/verify_payment`, values, config(token));
    case 'contactForm':
      return axios.post(`${authUrl}/contact/email`, values, config(token));
    case 'resendOpt':
      return axios.post(`${orderUrl}/order_otp`, values, config(token));

    default:
      break;
  }
}

export function getContent(type, token, values, id) {
  switch (type) {
    case 'userBillingAddresses':
      return axios.get(`${authUrl}/billingAddress/get`, config(token));
    case 'getUserOrders':
      return axios.get(`${orderUrl}/myOrders`, config(token));

    default:
      break;
  }
}
